import { humidityLvlColor } from '@/modules/common/utils/get-humidity-color';
import { BestPriceBuyerItem, IBestPriceBagItem } from '@/modules/mixing/store/analytical-mixing.store';
import { Humidity } from '@/shared/ui/icons';
import styles from './index.module.sass';
import arrowButton from '@@/mixing/components/recipes-detail/icons/arrow-button.svg';
import weightSvg from '@@/mixing/components/recipes-detail/icons/weight.svg';
import arrowWide from '@@/mixing/components/recipes-detail/icons/arrow-wide.svg';
import arrowIcon from '@@/mixing/components/recipes-detail/icons/arrow.svg';
import classNames from 'classnames';

export const TargetHumidity = ({ TARGET_MOISTURE, data, offer, className }: { className?: string, TARGET_MOISTURE: number, data: IBestPriceBagItem, offer?: BestPriceBuyerItem }) => {
    return (
        <div className={classNames(styles.targetHumidity, className)}>
          {+TARGET_MOISTURE === 0 ||
          (+TARGET_MOISTURE === +data.values.humidity && offer?.buyer) ? (
            <span className={styles.notRequired}>
              действий с влажностью <br />
              не требуется
            </span>
          ) : (
            <div className={styles.additional}>
              <span className={styles.callToAction}>
                {+TARGET_MOISTURE > +data.values.humidity
                  ? ' можно увлажнить'
                  : 'требуется осушение'}{' '}
                <img src={arrowButton} />
              </span>
              <div className={styles.params}>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>
                    <Humidity fill={humidityLvlColor(+data.values.humidity)} />{' '}
                    {data.values.humidity}%
                  </span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>
                    <Humidity fill={humidityLvlColor(+TARGET_MOISTURE)} />{' '}
                    {TARGET_MOISTURE}%
                  </span>
                </div>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>
                    <img src={weightSvg} alt="drop icon" />{' '}
                    {data.weight.toLocaleString('ru', {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}{' '}
                    т
                  </span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>
                    <img src={weightSvg} alt="" />{' '}
                    {(data.weight + data.weight_gain_tons).toLocaleString('ru', {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    })}{' '}
                    т
                  </span>
                </div>
                <div className={styles.paramLine}>
                  <span className={styles.paramItem}>н {data.values.nature}</span>
                  <img className={styles.arrow} src={arrowIcon} />
                  <span className={styles.paramItem}>н {data.new_nature}</span>
                </div>
              </div>
            </div>
          )}
          <img className={styles.arrowWide} src={arrowWide} alt="arrow wide" />
        </div>
    )
}